export default __webpack_public_path__ + "static/media/admin-leads.27ba0896.svg";